import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityScoresWidgetGroups} from "./entity-scores-widget.groups";
import React from "react";

export class EntityScoresWidgetLiveGroupsProps extends BaseProps {}

export const EntityScoresWidgetLiveGroups = ({controller, isSideBar}: EntityScoresWidgetLiveGroupsProps) => {
  const {state} = controller;
  const {entityContext, gamesByDateAndRound, shouldRenderTitle} = state;
  const {shouldRenderLiveGroups} = entityContext;

  const gamesListProps = {
    items: gamesByDateAndRound,
    shouldRenderTitle,
    controller,
    isSideBar
  };

  return shouldRenderLiveGroups ? <EntityScoresWidgetGroups {...gamesListProps} isLive={true}/> : null
};